import { deleteCookie } from 'cookies-next/client';

import { uiConfig } from '@/config';
import { AUTH_COOKIE, CENTRALIZED_LOGIN_IS_AUTHENTICATED } from '@/constants/cookies';
import { centralizedLogin } from '@/sdk/client/centralizedLogin';
import getQueryClient from '@/utils/getQueryClient';

import { mvpdLogOut } from './mvpdLogOut';

/**
 * Hard logout function.
 * Logs out the user by clearing the authentication cookie and redirecting to the core URL.
 * This will clear the session on fox.com and then redirect the user to auth.fox.com/logout to clear their centralized session too.
 * We usually want to call this when the user clicks a logout button, or maybe in some extreme errors, like if we fail fetching a valid token in the /callback page
 */
export async function hardLogOut(): Promise<void> {
  try {
    const queryClient = getQueryClient();

    queryClient.clear();

    await mvpdLogOut();
    deleteCookie(AUTH_COOKIE);
    deleteCookie(CENTRALIZED_LOGIN_IS_AUTHENTICATED);

    await centralizedLogin.logout({ redirectUri: uiConfig.coreUrl });
  } catch {}
}
